import word from "../assets/certificates/Word.jpg";
import ppt from "../assets/certificates/PowerPoint.jpg";
import php from "../assets/certificates/ITI certificate.jpg";
import ibm from "../assets/certificates/IBM Data Engineering.jpg";
import ggl from "../assets/certificates/ggl_data_analysis.png"

const certificates = [
    {
        id: 1,
        title: "Google Data Analytics Professional Certificate",
        monthYear: "Jan 2025",
        whatLearned: "Completed the Google Data Analytics Professional Certificate. Gained hands-on experience in data cleaning, analysis, and visualization using tools such as spreadsheets, SQL, R, and Tableau, with a strong focus on data-driven decision-making and real-world business case studies.",
        img: ggl,
        issuer: "Coursera",
        link: "https://www.coursera.org/account/accomplishments/professional-cert/2VUND7I7AYB0",
    },
    {
        id: 2,
        title:"IBM Data Engineering Professional Certificate",
        monthYear: "Nov 2024",
        whatLearned: "Completed a professional certificate program in data engineering offered by IBM. Gained skills in data modeling, ETL processes, big data technologies, and cloud computing.",
        img: ibm,
        issuer: "Coursera",
        link: "https://www.coursera.org/account/accomplishments/professional-cert/JT2WQV9HZHLZ",
    },
    {
        id: 3,
        title: "Full Stack Web Development using PHP",
        monthYear: "Jul 2024",
        whatLearned: "Completed a comprehensive course on full stack web development using PHP, covering both front-end and back-end technologies. Gained skills in database management, server-side scripting, and responsive design.",
        img: php,
        issuer: "Information Technology Institute (ITI)",
        link: "https://drive.google.com/file/d/1YuPf_EmOgRlZ17vlvsIonSclWyoX0mxZ/view?usp=drive_link",
    },
    {
        id: 4,
        title: "Microsoft Office Specialist Expert Word 2010",
        monthYear: "Aug 2018",
        whatLearned: "Achieved expert-level proficiency in Microsoft Word 2010. Mastered advanced document formatting, collaboration tools, and automation features, including macros and templates.",
        img: word,
        issuer: "Microsoft",
        link: "https://drive.google.com/file/d/1hNtKZb82TBZvvvlbdU1tRkcFHLqmbMx4/view?usp=drive_link",
    },
    {
        id: 5,
        title: "Microsoft Office Specialist PowerPoint 2010",
        monthYear: "Sep 2017",
        whatLearned: "Gained expertise in creating engaging presentations using Microsoft PowerPoint 2010. Learned about advanced features such as animations, transitions, and multimedia integration.",
        img: ppt,
        issuer: "Microsoft",
        link: "https://drive.google.com/file/d/1hNtKZb82TBZvvvlbdU1tRkcFHLqmbMx4/view?usp=drive_link",
    }
];

export const getCertificatesData = () => {
    return certificates;
};
